// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"page-description_descriptionContainer__kPZ8Y","description":"page-description_description__pMJ78"};